import { uploadFile, uploadVideoFile } from "@/utils/UploadFile";

const getUploadKey = (session) =>
  session?.uploadKey ||
  session?.snCode ||
  session?.orderDetail?.snCode ||
  session?.orderDetail?.ssn ||
  session?.order?.snCode ||
  session?.order?.data?.snCode ||
  session?.order?.data?.ssn ||
  "";

const uploadLegacyFile = async (file, session) => {
  if (!file) return "";

  const url = await uploadFile(file, getUploadKey(session));
  if (!url) throw new Error("Legacy upload did not return a file URL.");
  return url;
};

const uploadLegacyDocument = async (file, session) => {
  if (!file) return "";
  if (!file.type?.startsWith("video/")) {
    return uploadLegacyFile(file, session);
  }

  const url = await uploadVideoFile(
    file,
    getUploadKey(session),
    "identity-document",
  );
  if (!url) throw new Error("Legacy upload did not return a video URL.");
  return url;
};

export const legacyUploadAdapter = {
  uploadDocument: uploadLegacyDocument,
  uploadSelfie: uploadLegacyFile,
  uploadAddressProof: uploadLegacyFile,
  getUploadKey,
};
